import { render, staticRenderFns } from "./sharedResourceProductDialog.vue?vue&type=template&id=221f57be&scoped=true"
import script from "./sharedResourceProductDialog.vue?vue&type=script&lang=js"
export * from "./sharedResourceProductDialog.vue?vue&type=script&lang=js"
import style0 from "./sharedResourceProductDialog.vue?vue&type=style&index=0&id=221f57be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f57be",
  null
  
)

export default component.exports